<template>
    <div class="profile-board test-editor-results">

      <h2 v-if="(loading.results || loading.candidate)">Загрузка...</h2>
      <h2 v-else-if="!res">Тест не завершен</h2>

        <div v-else class="row mt-2 mt-md-8">
            <div class="col-12 pa-3">
                <h3 class="rep-test-title">{{ testData.name }}</h3>
                <hr class="mt-7 mb-4">
                    <div class="profnavigator-list">
                        <div v-for="(prof, indProf) in positions(testData)" :key="indProf" class="profnavigator-item">
                            <Scale10ColorBlocksTeamStability
                                :value="prof.value"
                                :rawValue="prof.raw_value ? prof.raw_value : prof.value"
                                :normalizedTo="prof.block ? prof.block.normalized_to : 10"
                            />
                            <div class="profnavigator-item-title">{{ prof.block ? prof.block.title : "Без названия" }}</div>
                        </div>
                    </div>
                    <h4 class="desc-title">{{ testData.test_results_title ? testData.test_results_title : '' }} </h4>
                    <p v-if="testData.test_results_description">
                        {{ testData.test_results_description }}
                    </p>
                    <div v-for="(prof, indProf) in top3positions(testData)" :key="indProf" class="desc-item" :class="getBlockClass(prof)">
                        <div class="desc-item-title">{{ prof.block ? prof.block.title : "Без названия" }}</div>
                        <div class="desc-item-text" v-html="sanitizeRichHtml(prof.text)" />
                        <!-- Рекомендации на саму платформу вообще не идут - только описание -->
                        <!-- <template v-if="prof.recommendation">
                            <div class="desc-item-title">Рекомендации</div>
                            <div class="desc-item-text" v-html="sanitizeRichHtml(prof.recommendation)" />
                        </template> -->
                    </div>
            </div>
        </div>

    </div>
</template>

<script>
/* eslint-disable */
import Scale10ColorBlocksTeamStability from "./Scale10ColorBlocksTeamStability.vue";
import { mapActions, mapGetters } from "vuex";
import { sanitizeRichHtml } from "@/common/util"
import { getColorZone } from '@/common/colorBlocks.js'

export default {
    components: {
        Scale10ColorBlocksTeamStability
    },
    data() {
        return {
        };
    },
    props: ['testCode'],
    computed: {
        ...mapGetters({
            user: 'auth/user',
            res: 'users/candidate/results',
            loading: 'users/candidate/loading',
            loadingCandidate: 'users/candidate/loading',
        }),
        getScaleLimit() {
            return 10;
        },
        testData() {
            return this.res?.constructor_test_results && this.res.constructor_test_results[this.testCode] 
                ? this.res.constructor_test_results[this.testCode] 
                : { name: "Отчет не найден", blocks: [] }
        },
        candidateId() {
            return this.user.user_type === CANDIDATE ? this.user.id : this.$route.params.id;
        },
    },
    methods: {
        ...mapActions({
        }),
        sanitizeRichHtml,
        positions(testData) {
            const arr = [...testData.blocks]
            arr.sort((a, b) => b?.value - a?.value)
            return arr
        },
        top3positions(testData) {
            if (this.testCode==='MOSTURISM')
                return this.positions(testData).slice(0, 3)
            else
                return this.positions(testData)
        },
        getBlockClass(prof, indProf, indBlock) {
            const normalizedTo = prof.block ? prof.block.normalized_to : 10
            const valueNorm = Math.floor((+prof.value) / (+normalizedTo) * 10)
            const zone = getColorZone(valueNorm)
            return `item-block-${zone}-light`
        },
    },
};
</script>


<style scoped lang="scss">
@import "src/assets/styles/variables";


.test-editor-results h3 {
    font-size: 1.6rem;
}

.test-editor-results .profnavigator-item {
    display: flex;
    align-items: center;
    margin: 20px 0;
}


.test-editor-results .desc-item.item-block-green-light {
    background: #E8F8EF;
    border-color: #6FCF97;
}
.test-editor-results .desc-item.item-block-red-light {
    background: #FCD0D0;
    border-color: #E53E3E;
}
.test-editor-results .desc-item.item-block-yellow-light {
    background: #FFF8E5;
    border-color: #F2C94C;
}



.test-editor-results .profnavigator-item-title {
    margin: 40px 0 0 30px;
    font-size: 16px;
    font-weight: bold;
}

.test-editor-results .desc-title {
    font-size: 20px;
    font-weight: bold;
}

.test-editor-results .desc-item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0px 0 8px 0;
}

.test-editor-results .desc-item {
    background: var(--color-bg);
    padding: 20px 10px 10px 20px;
    margin: 20px 0;
    border-radius: 5px;
}

.test-editor-results .desc-item-text {
    padding: 10px;
    border-radius: 10px;
}

.test-editor-results .desc-item-text p {
    margin-bottom: 5px !important;
}



@media screen and (max-width: 600px) {
    .test-editor-results .profnavigator-item {
        margin: 10px 0;
    }

    .test-editor-results .profnavigator-item-value {
        margin-left: 10px;
        font-size: 14px;
    }

    .test-editor-results .profnavigator-item-title {
        margin-left: 10px;
        font-size: 14px;
    }

}
.rep-top-title {
  font-size: 28px;
  color: #4f62a4;
}

.rep-test-title  {
  font-size: 24px;
}


</style>
